module.exports = __webpack_public_path__ + "static/media/godkanna.348a004a.mp3";